import type { Session } from '@lastrouter/contracts';
import { useEffect } from 'react';
import { setCsrfToken } from '../api/client.js';
import { useApiQuery } from '../api/hooks.js';

/** Sessão atual; guarda o token anti-CSRF para as mutações. 401 vira "sem sessão", não erro. */
export function useSession() {
  const q = useApiQuery('session', undefined, { retry: false, staleTime: 60_000 });
  useEffect(() => {
    setCsrfToken(q.data?.csrf_token ?? null);
  }, [q.data]);
  return q;
}

export function isOwnerOrAdmin(s: Session | undefined): boolean {
  return Boolean(s && (s.is_admin || s.owner_of.length > 0));
}
